/* Cart island — keep the floating pill in step with the cart.

   The pill is rendered server-side, so it is already correct on load. This
   only has to re-render it after an in-page cart change, which it does through
   the Section Rendering API, the same way the cart drawer refreshes. */
(function () {
  'use strict';

  var SECTION = 'cart-island';
  var refreshing = false;

  async function refresh() {
    var island = document.querySelector('[data-cart-island]');
    if (!island || refreshing) return;
    refreshing = true;

    try {
      var res = await fetch(window.location.pathname + '?sections=' + SECTION);
      if (!res.ok) return;
      var data = await res.json();
      var html = data[SECTION];
      if (typeof html !== 'string') return;

      /* The response is the whole section wrapper, so pull the island out of
         it rather than nesting one inside the other. */
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-island]');
      if (fresh) island.innerHTML = fresh.innerHTML;
    } catch (e) {
      /* A failed refresh leaves the last good pill on screen, which is a
         better outcome than clearing it. */
    } finally {
      refreshing = false;
    }
  }

  document.addEventListener('lj:cart:updated', refresh);
})();
